import {DateOnly} from '@amicamutual/amica-common';
import {AxiosError} from 'axios';

import {CreateAccountValidationErrors} from 'features/CreateAccount/enums';
import {ProvisioningResponse, ValidationResponse} from 'features/CreateAccount/types';
import {ProvisioningError, ProvisioningWithLoginIDError, ValidationError} from 'features/CreateAccount/types/error';
import {buildPreloginAmicaApiRequest} from 'shared/APIServices/utils/unauthenticatedAPIRequest';

export const provisionAccount = ({
  firstName,
  lastName,
  dateOfBirth,
  scsKey
}: {
  firstName: string;
  lastName: string;
  dateOfBirth: DateOnly;
  scsKey: string;
}) =>
  buildPreloginAmicaApiRequest({
    url: '/web-user/provision',
    method: 'post',
    data: {
      scsKey,
      firstName,
      lastName,
      dateOfBirth
    }
  })
    .then((response): ProvisioningResponse => response.data)
    .catch((error: AxiosError<any>) => {
      throw new ProvisioningError({
        error
      });
    });

export const provisionAccountWithLoginID = ({
  token,
  loginID,
  sessionId
}: {
  token: string;
  loginID: string;
  sessionId: string;
}) =>
  buildPreloginAmicaApiRequest({
    url: `/web-user/provision/${sessionId}`,
    method: 'post',
    data: {
      token,
      userName: loginID
    }
  })
    .then((response): ProvisioningResponse => response.data)
    .catch((error: AxiosError<any>) => {
      throw new ProvisioningWithLoginIDError({
        error
      });
    });

export const validateAccount = ({validationString, sessionId}: {validationString: string; sessionId: string}) =>
  buildPreloginAmicaApiRequest({
    url: `/web-user/validate/${sessionId}`,
    method: 'post',
    data: {
      validationString
    }
  })
    .then((response) => {
      const {data}: {data: ValidationResponse} = response;
      if (!data.token) {
        throw new ValidationError({errorCode: CreateAccountValidationErrors.INTERNAL_SERVER_ERROR});
      }
      return data;
    })
    .catch((error: AxiosError<any>) => {
      throw new ValidationError({error});
    });
